// extracted by mini-css-extract-plugin
export default {"group":"tHZnALOP7b","horizontal":"_5gWbv229Oz","group-checkbox":"_6m66ZLruth","groupCheckbox":"_6m66ZLruth"};